import { APIErrorContext, IError } from "./APIErrorProvider";
import { useContext } from "react";

function useAPIError(): IError {
  const { message, type, showDialog, addError, removeError } = useContext(APIErrorContext);
  return { message, type, showDialog, addError, removeError };
}

export default useAPIError;
